export const landingpageFTs = {
  uploadCV: { dev: true, sit: true, uat: true, prod: true },
}